import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NullToNotAvailablePipe } from './null-to-not-available.pipe';

@Pipe({
  name: 'carrierDetails',
})
export class CarrierDetailsPipe implements PipeTransform {
  constructor(private translateService: TranslateService, private nullToNotAvailablePipe: NullToNotAvailablePipe) {}

  transform({
    carrierId,
    carrierName,
    carrierNumber,
  }: {
    carrierId: string;
    carrierName: string;
    carrierNumber: string;
  }): string {
    if (!carrierId && !carrierName && !carrierNumber) {
      return null;
    }
    const nameRow = `${this.translateService.instant(
      'common.list.th.carrierName',
    )}: ${this.nullToNotAvailablePipe.transform(carrierName)}`;
    const idRow = `${this.translateService.instant('common.field.carrierId')}: ${this.nullToNotAvailablePipe.transform(
      carrierId,
    )}`;
    const numberRow = `${this.translateService.instant(
      'common.field.carrierNumber',
    )}: ${this.nullToNotAvailablePipe.transform(carrierNumber)}`;

    return [nameRow, idRow, numberRow].join(',\r\n');
  }
}
